import React from 'react';

import { Link } from 'react-router-dom';
import Header from './header';
import Banner from './banner';
import Footer from './footer';

function NoMatch() {
  return (
    <div >
     <Header />
     <Banner />
     <h1>THIS PAGE DOES NOT EXIST</h1>
     <h4> FOR HOME GO TO</h4><Link to="/"><button className='sign-in'>Home</button></Link>
     <h4> FOR SIGNIN GO TO</h4><Link to="/signin"><button className='sign-in'>SignIn </button></Link>
     <h4> FOR SIGNUP GO TO</h4><Link to="/signup"><button className='sign-in'>SignUp</button></Link>
     <h4> TO SEE OUR FLEETS GO TO</h4><Link to="/allfleets"><button className='sign-in'>View All Fleet</button></Link>
     <h4> FOR KNOWING MORE GO TO</h4><Link to="/help"><button className='sign-in' id="rotate">More</button></Link>
     <Footer />
    </div>
  );
}

export default NoMatch;